































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TopMenu extends Vue {
    //nothing much going on here..

    app = "prod";
    constructor() {
        super();
        if(document.location.hostname == "localhost") this.app = "dev";
    }

    apihost = "https://apred1.ibrc.iupui.edu";
    /*
    signup() {
        //alert('Sign up is only applicable for EDA staff. Please con^tact APRED team for more information.');
        document.location.href = this.apihost+"/auth/#!/signup?app="+this.app;
    }

    login() {
        document.location.href = this.apihost+"/auth/#!/login?app="+this.app;
    }

    settings() {
        document.location.href = this.apihost+"/auth/#!/settings/account?app="+this.app;
    }

    signout() {
        (this.$root as any).signout();
    }
    */
}
